import React from 'react';
import { translations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';

function ProductCard({ product, onClick }) {
  const { t } = useLanguage();

  return (
    <div className="product-card" onClick={() => onClick(product)}>
      <div className="product-image-container">
        <img
          src={product.images[0]}
          alt={t(product.name)}
          className="product-image"
          loading="lazy"
        />
        <div className="product-badge">
          <span className="badge-power">{product.power}</span>
          <span className="badge-area">{product.area}</span>
        </div>
        <div className="product-overlay">
          <span className="overlay-text">{t(translations.productCard.viewGallery)}</span>
        </div>
      </div>

      <div className="product-info">
        <h3 className="product-name">{t(product.name)}</h3>
        <p className="product-model">{t(translations.productCard.model)}: {product.model}</p>

        <div className="product-specs">
          <div className="spec-item">
            <span className="spec-label">{t(translations.productCard.power)}:</span>
            <span className="spec-value">{product.power}</span>
          </div>
          <div className="spec-item">
            <span className="spec-label">{t(translations.productCard.area)}:</span>
            <span className="spec-value">{product.area}</span>
          </div>
          <div className="spec-item">
            <span className="spec-label">{t(translations.productCard.size)}:</span>
            <span className="spec-value">{product.size}</span>
          </div>
          <div className="spec-item">
            <span className="spec-label">{t(translations.productCard.control)}:</span>
            <span className="spec-value">{product.wireless}</span>
          </div>
          <div className="spec-item">
            <span className="spec-label">{t(translations.productCard.materials)}:</span>
            <span className="spec-value">{t(product.materials)}</span>
          </div>
          <div className="spec-item">
            <span className="spec-label">{t(translations.productCard.installation)}:</span>
            <span className="spec-value">{t(product.installation)}</span>
          </div>
        </div>

        <p className="product-description">{t(product.description)}</p>

        <div className="product-footer">
          <span className="product-price">{product.price}</span>
          <a
            href="tel:+393513857921"
            className="btn btn-primary btn-small"
            onClick={(e) => e.stopPropagation()}
          >
            {t(translations.productCard.order)}
          </a>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
